// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:06
import { TrafficFlowResult_abstract } from './../abstract/SagaBase/TrafficFlowResult_abstract';
export class TrafficFlowResult extends TrafficFlowResult_abstract {}
